// extracted by mini-css-extract-plugin
module.exports = {"Markdown":"markdown_Markdown__ifwjl typography_bodyFont__Sn75r"};